<template>
  <div class="project-mixin">
    {{ projectNames }}
  </div>
</template>

<script>
export default {
  name: 'ProjectMixin',
  components: {},
  props: {},
  data() {
    return {
      projectNames: []
    }
  },
  methods: {
    getProjectNames(list) {
      return list.map((item) => item.name).join('、')
    }
  }
}
</script>

<style scoped></style>
